var Http = (function(){
	'use strict';

	function Request(method, endpoint, params) {
		//instantiate new request
		endpoint = process.env.VUE_APP_ROOT_API + endpoint;
		var xhr = new XMLHttpRequest();
		if (method == 'GET' && params.data) {
			endpoint += '?';
			for (var k in params.data) {
				endpoint += k + '=' + params.data[k] + '&';
			}
			endpoint = endpoint.slice(0, -1);
		}
		xhr.open(method, endpoint, true);
		if (localStorage.getItem('token')) { xhr.setRequestHeader('Authorization', localStorage.getItem('token')); }
		if (params.data) { xhr.setRequestHeader('Content-type', 'application/json'); }
		if (params.OnResponse) {
			xhr.onreadystatechange = function() {
				if (xhr.readyState == XMLHttpRequest.DONE) {
					params.OnResponse(JSON.parse(xhr.responseText));
				}
			}.bind(this);
		}
		xhr.send(params.data ? JSON.stringify(params.data) : null);
	}

	return {
		Request : Request
	};
}());

export { Http };